export default __webpack_public_path__ + "static/media/alert.inline.3128839e.svg";